export const MAX_CHUNK_SIZE = 99 * 1024 * 1024; // 99Mb
export const MAX_VIDEO_SIZE = 500 * 1024 * 1024; // 500Mb
export const MAX_IMAGE_SIZE = 30 * 1024 * 1024; // 30Mb
